var Vue = require('vue');
var PaymentStatus = require('./PaymentStatus.vue').default;

module.exports = function() {
  new Vue({
    el: '#payment-status',
    components: {
      'payment-status': PaymentStatus
    }
  });
};
